import Reveal from "@/components/Reveal";
import { SIMULATOR_URL } from "@/components/Nav";

const PAPERS = [
  {
    badge: "Nature Photonics",
    badgeClass: "border-beam/40 bg-beam/10 text-beam",
    title: "Deep learning with coherent nanophotonic circuits",
    authors: "Shen et al. · 2017",
  },
  {
    badge: "Nature",
    badgeClass: "border-white/30 bg-white/10 text-zinc-100",
    title: "Inference in artificial intelligence with deep optics and photonics",
    authors: "Wetzstein et al. · 2020",
  },
  {
    badge: "Nature",
    badgeClass: "border-white/30 bg-white/10 text-zinc-100",
    title: "Parallel convolutional processing using an integrated photonic tensor core",
    authors: "Feldmann et al. · 2021",
  },
  {
    badge: "Physical Review X",
    badgeClass: "border-amber-300/40 bg-amber-300/10 text-amber-300",
    title: "Large-scale optical neural networks based on photoelectric multiplication",
    authors: "Hamerly et al. · 2019",
  },
  {
    badge: "Journal of Lightwave Technology",
    badgeClass: "border-violet-400/40 bg-violet-400/10 text-violet-300",
    title: "Fundamentals of Coherent Optical Fiber Communications",
    authors: "Kikuchi · 2016",
    wide: true,
  },
];

export default function CredibilitySection() {
  return (
    <section id="credibility" className="relative pb-28 md:pb-40" data-testid="credibility-section">
      <div className="container-x">
        <Reveal>
          <p className="eyebrow mb-4 text-laser">— Grounded in the Literature</p>
          <h2 className="max-w-3xl text-4xl font-semibold tracking-tighter md:text-5xl">
            Built on peer-reviewed photonic computing research.
          </h2>
          <p className="mt-5 max-w-2xl font-mono text-xs leading-relaxed text-zinc-500">
            The simulator&apos;s physics models, non-ideality equations, and throughput analysis
            are derived from the following landmark papers.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2">
          {PAPERS.map((paper, i) => (
            <Reveal key={paper.title} delay={0.05 * i} className={paper.wide ? "md:col-span-2" : ""}>
              <div
                className="h-full rounded-lg border border-white/10 bg-panel p-6"
                style={{ boxShadow: "inset 0 0 30px rgba(61,107,255,0.07)" }}
                data-testid={`citation-card-${i + 1}`}
              >
                <span
                  className={`inline-block rounded-full border px-3 py-1 font-mono text-[9px] uppercase tracking-[0.2em] ${paper.badgeClass}`}
                >
                  {paper.badge}
                </span>
                <p className="mt-4 font-mono text-sm leading-relaxed text-zinc-200">{paper.title}</p>
                <p className="mt-3 font-mono text-xs text-zinc-500">{paper.authors}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-10 text-center font-mono text-xs text-zinc-500">
            <a
              href={SIMULATOR_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="theory-link"
              className="text-beam transition-colors hover:underline"
            >
              Physics equations and transfer functions are documented in full on the simulator&apos;s
              Theory page.
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
